import { css } from 'styled-components';

export const focusStyle = css`
  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.elvitaWebPurple};
    outline-offset: 2px;
  }
`;
